import axios from '@fs/zion-axios'
import { getUnlocalizedLocations } from './locationMappers'
import type { GetLocationsOptions, Iso3166Location } from './types'

export default async function fetchLocationsFromCis({
  unlocalizedLocations = getUnlocalizedLocations(),
  language,
}: GetLocationsOptions): Promise<Iso3166Location[]> {
  const {
    data: { countries: locations },
  } = await axios.get(`/service/ident/cis/cis-public-api/v4/countries/${language}`)
  return locations
    .filter(({ code2 }) => unlocalizedLocations.find(({ alpha2 }) => code2 === alpha2))
    .map(({ code, code2, value }) => ({ alpha2: code2, alpha3: code, text: value }))
}
